<div>
  <div class="main-print">
  <mat-icon [matTooltip]="'AppointmentPage.print' | translate" (click)="OnListPrint()">print</mat-icon>
</div>
  <mat-tab-group class="tabGroupPersonalDetails tabData tab-container mx-2" (selectedTabChange)="setTab($event);">

    <mat-tab class="tabSubPersonalDetails1" [(ngModel)]="activeTab" ngDefaultControl style="margin-left:5px">
      <ng-template mat-tab-label>{{"MergeListPage.mergedPatientList" | translate}}</ng-template>
      <div class="table-height">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mat-header mat-elevation-z8"
  >
    <ng-container matColumnDef="radio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <mat-radio-group
          aria-labelledby="example-radio-group-label" 
          class="example-radio-group"
          [(ngModel)]="selectedPerson"
        >
          <mat-radio-button
            [value]="row"
            (click)="selectedRow(row)"
          ></mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>

    <ng-container matColumnDef="primaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef  class="custom-header">
        {{"MergeListPage.primaryGenderAge" | translate}}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
        <div class="cell-content">
          <img src="./assets/images/{{ generalApiService.getGenderValue(element.primaryGender) }}" alt="image" class="patient-image" />
          <div class="patient-details">
            <strong class="Age-font">{{ element.firstAge }}</strong>
            <span>{{ element.primaryDob }} {{ generalApiService.getGender(element.primaryGender) }}</span>
          </div>
        </div>
      </td>            
    </ng-container>

    <ng-container matColumnDef="primarymrn">
      <th mat-header-cell *matHeaderCellDef  class="custom-header">
        {{"MergeListPage.primaryPatient" | translate}}
      </th>
      <td mat-cell class="col-nowrap" *matCellDef="let element" 
      [ngClass]="{
        'long-name': element.firstName.length > 25
      }"
      >
        <div>
          <div class="name-div">
          <strong class="name-container">{{ element.PrimaryPatientNameLangBase || element.firstName }}</strong><br>
          </div>
          <span class="doctor-name">{{ element.primaryMrn }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="secondaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef  class="custom-header">
       {{"MergeListPage.secondaryGenderAge" | translate}}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
        <div class="cell-content">
          <img src="./assets/images/{{ generalApiService.getGenderValue(element.seondaryGender) }}" alt="image" class="patient-image" />
          <div class="patient-details">
            <strong class="Age-font">{{ element.secondAge }}</strong>
            <span>{{ element.secondaryDob }} {{ generalApiService.getGender(element.seondaryGender) }}</span>
          </div>
        </div>
      </td>            
    </ng-container>

    <ng-container matColumnDef="secondarymrn">
      <th mat-header-cell *matHeaderCellDef  class="custom-header">
        {{"MergeListPage.secondaryPatient" | translate}}
      </th>
      <td mat-cell class="col-nowrap" *matCellDef="let element" 
      [ngClass]="{
        'long-name': element.secondName.length > 25
      }"
      >
        <div>
          <div class="name-div">
          <strong class="name-container">{{ element.SecondaryPatientNameLangBase || element.secondName }}</strong><br>
          </div>
          <span class="doctor-name">{{ element.secondaryMrn }}</span>
        </div>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="primarymrn">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.primarymrn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.primaryMrn }}</td>
    </ng-container>
    <ng-container matColumnDef="primaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.primaryPatientDetails" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
    </ng-container>
    <ng-container matColumnDef="secondarymrn">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.secondarymrn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.secondaryMrn }}</td>
    </ng-container>

    <ng-container matColumnDef="secondaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.secondaryPatientDetails" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.secondaryPatientDetails }}
      </td>
    </ng-container> -->
    <ng-container matColumnDef="mergedReason">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.mergeReason" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font"> {{ element.mergedReason}}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="unMergedReason">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.mergedremark" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
       <strong class="Age-font merged-remarks">
          {{ element.mergedRemarks }}
       </strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="mergedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ "adt.performedBy" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font">{{ element.mergedBy}}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="unMergedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ "adt.performedon" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font">{{element.mergedOn  }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="custom-header">
        {{ "EncounterListPage.status" | translate }}
      </th>
       <td mat-cell *matCellDef="let element">
         <span
          class="status-box"
      [ngStyle]="{ 'background-color': getstatusColor(element.status)?.backgroundColor }"
         >
      {{ getstatusColor(element.status)?.text }}
       </span>
       </td>
    </ng-container>
    <!-- <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.status" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container> -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.action" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon matTooltip="Print" (click)="onPrintClick(element)">print</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  </div>
  </mat-tab>
  <mat-tab class="tabSubPersonalDetails1" [(ngModel)]="activeTab" ngDefaultControl style="margin-left:5px">
    <ng-template mat-tab-label>{{"MergeListPage.mergedUnmergePatientList" | translate}}</ng-template>
    <div class="table-height">
    <table
    mat-table
    [dataSource]="dataSourceHistory"
    matSort
    class="mat-header mat-elevation-z8"
  >
  <ng-container matColumnDef="primaryPatientDetails">
    <th mat-header-cell *matHeaderCellDef  class="custom-header">
     {{"MergeListPage.primaryGenderAge" | translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
      <div class="cell-content">
        <img src="./assets/images/{{ generalApiService.getGenderValue(element.primaryGender) }}" alt="image" class="patient-image" />
        <div class="patient-details">
          <strong class="Age-font">{{ element.firstAge }}</strong>
          <span>{{ element.primaryDob  }} / {{ generalApiService.getGender(element.primaryGender) }}</span>
        </div>
      </div>
    </td>            
  </ng-container>

  <ng-container matColumnDef="primarymrn">
    <th mat-header-cell *matHeaderCellDef  class="custom-header">
      {{"MergeListPage.primaryPatient" | translate}}
    </th>
    <td mat-cell class="col-nowrap" *matCellDef="let element" 
    [ngClass]="{
      'long-name': element.firstName.length > 25
    }"
    >
      <div>
        <div class="name-div">
        <strong class="name-container">{{ element.firstName }}</strong><br>
        </div>
        <span class="doctor-name">{{ element.primaryMrn }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="secondaryPatientDetails">
    <th mat-header-cell *matHeaderCellDef  class="custom-header">
    {{"MergeListPage.secondaryGenderAge" | translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
      <div class="cell-content">
        <img src="./assets/images/{{ generalApiService.getGenderValue(element.seondaryGender) }}" alt="image" class="patient-image" />
        <div class="patient-details">
          <strong class="Age-font">{{ element.secondAge }}</strong>
          <span>{{ element.secondaryDob }} / {{ generalApiService.getGender(element.seondaryGender) }}</span>
        </div>
      </div>
    </td>            
  </ng-container>

  <ng-container matColumnDef="secondarymrn">
    <th mat-header-cell *matHeaderCellDef  class="custom-header">
      {{"MergeListPage.secondaryPatient" | translate }}
    </th>
    <td mat-cell class="col-nowrap" *matCellDef="let element" 
    [ngClass]="{
      'long-name': element.secondName.length > 25
    }"
    >
      <div>
        <div class="name-div">
        <strong class="name-container">{{ element.secondName }}</strong><br>
        </div>
        <span class="doctor-name">{{ element.secondaryMrn }}</span>
      </div>
    </td>
  </ng-container>
    <!-- <ng-container matColumnDef="primarymrn">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.primarymrn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.primaryMrn }}</td>
    </ng-container>
    <ng-container matColumnDef="primaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.primaryPatientDetails" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.primaryPatientDetails }}</td>
    </ng-container>
    <ng-container matColumnDef="secondarymrn">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.secondarymrn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.secondaryMrn }}</td>
    </ng-container>

    <ng-container matColumnDef="secondaryPatientDetails">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.secondaryPatientDetails" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.secondaryPatientDetails }}
      </td>
    </ng-container> -->
    <ng-container matColumnDef="mergedReason">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.reason" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font"> {{ element.reason}}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="unMergedReason">
      <th mat-header-cell *matHeaderCellDef>
        {{ "EncounterPage.remark" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font merged-remarks">{{element.remarks }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="mergedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ "adt.performedBy" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font">{{ element.performedBy}}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="unMergedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ "adt.performedon" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="Age-font"> {{element.performedOn }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="custom-header">
        {{ "EncounterListPage.status" | translate }}
      </th>
       <td mat-cell *matCellDef="let element">
         <span
          class="status-box"
      [ngStyle]="{ 'background-color': getstatusColor(element.status)?.backgroundColor }"
         >
      {{ getstatusColor(element.status)?.text }}
       </span>
       </td>
    </ng-container>
    <!-- <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MergeListPage.status" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container> -->


    <tr mat-header-row *matHeaderRowDef="displayedColumnUnmerged; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnUnmerged"></tr>
  </table>
</div>
  </mat-tab>
  </mat-tab-group>
</div>
<div class="modal-footer modalFooterAddItem" *ngIf="!isButtonShow">
  <mat-form-field
    class="fieldBoxwidth"
    style="padding-top: 10px; padding-left: 20px"
    appearance="outline"
  >
    <mat-label>{{ "payerInfo.reason" | translate }}</mat-label>
    <mat-select [(ngModel)]="reason" name="reason" [required]="true">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="reasonSearch"
          [placeholderLabel]="'reason'"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let reasons of reasonSample" [value]="reasons.code">
        {{ reasons.desc }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field
    style="padding-top: 10px; padding-left: 20px"
    class="fieldBoxwidth"
    appearance="outline"
  >
    <mat-label>{{ "EncounterListPage.remarks" | translate }}</mat-label>
    <input
      matInput
      [placeholder]="'EncounterListPage.remarks' | translate"
      [(ngModel)]="remarks"
      name="remarks"
      maxlength="255"
    />
  </mat-form-field>
  &nbsp;
  <button (click)="unMergePatient()" class="btnCyan right" mat-mini-fab matTooltip="{{ 'payerInfo.save' | translate }}">
    <mat-icon >sim_card</mat-icon>
  </button>
</div>
<!-- <div class="refresh-block">
  <mat-grid-list cols="10" rowHeight="70px">
    <mat-grid-tile [colspan]="1">
      <mat-icon
      class="cyanFont green"
      (click)="refreshSearch()"
      matTooltip="{{ 'adt.refresh' | translate }}"
      data-automation-attribute="icon-cancel"
      >refresh</mat-icon
    >
    </mat-grid-tile>
    <mat-grid-tile [colspan]="3"></mat-grid-tile>
    <mat-grid-tile [colspan]="3"></mat-grid-tile>
    <mat-grid-tile [colspan]="3">
      <mat-paginator
        [length]="totalDataLength"
        [pageSize]="pageSize"
        (page)="getNext($event)"
        #paginator
        [pageSizeOptions]="paginatorOptions"
      >
      </mat-paginator>
    </mat-grid-tile>
  </mat-grid-list>
</div> -->


<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="0"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>